import React from 'react'
import clsx from 'clsx'

interface HeaderProps {
  title: string
  className?: string
}

interface TextProps {
  text: string
  className?: string
}

interface PillProps {
  text: string | number
  color?: string
  textcolor?: string
}

export const Header1: React.FC<HeaderProps> = ({ title }) => (
  <h1 className='text-xl font-light leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight'>
    {title}
  </h1>
)

export const Header2: React.FC<HeaderProps> = ({ title }) => (
  <h2 className='mb-4 text-lg font-light leading-7 text-slate-800 sm:truncate sm:text-xl sm:tracking-tight'>
    {title}
  </h2>
)

export const Header3: React.FC<HeaderProps> = ({ title }) => (
  <h3 className='mb-4 text-base font-light leading-7 text-sky-600 sm:truncate sm:text-lg sm:tracking-tight'>
    {title}
  </h3>
)

export const Header4: React.FC<HeaderProps> = ({ title }) => (
  <h4 className='text-sm mb-2 font-light text-gray-900'>{title}</h4>
)

export const PLarge: React.FC<TextProps> = ({ text, className }) => (
  <p className={clsx('text-lg font-light text-gray-900', className)}>{text}</p>
)

export const PMedium: React.FC<TextProps> = ({ text, className }) => (
  <p className={clsx('flex-1 truncate px-4 py-2 text-base font-light', className)}>{text}</p>
)

export const PSmallFaded: React.FC<TextProps> = ({ text, className }) => (
  <p className={clsx('text-sm text-gray-500', className)}>{text}</p>
)

export const PSmallStrong: React.FC<TextProps> = ({ text, className }) => (
  <p className={clsx('text-sm font-light text-gray-700', className)}>{text}</p>
)

export const Pill: React.FC<PillProps> = ({ text, color = 'slate', textcolor }) => {
  const bgcolor = `bg-${color}-100`
  const textColorClass = textcolor ? `text-${textcolor}-800` : `text-${color}-800`

  return (
    <span
      className={clsx(
        'rounded-full px-2 py-1 text-xs font-medium',
        bgcolor,
        textColorClass
      )}
    >
      {text}
    </span>
  )
}
